import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { Loader2 } from 'lucide-react';
import api from '../../lib/api';
import { toast } from 'sonner';

export default function CommunicationModal({ 
  isOpen, 
  onClose, 
  beneficiario 
}) {
  const [sendingEmail, setSendingEmail] = useState(false);

  const emailTemplates = [
    { 
      type: 'bienvenida', 
      name: 'Bienvenida', 
      description: 'Mensaje de bienvenida al programa', 
      color: '#10B981' 
    },
    { 
      type: 'informacion_beneficio', 
      name: 'Informacion del Beneficio', 
      description: 'Resumen financiero y colores seleccionados', 
      color: '#3B82F6' 
    },
    { 
      type: 'verificacion', 
      name: 'Verificacion de Documentos', 
      description: 'Notificacion de documentos en verificacion (72h)', 
      color: '#F5A623' 
    },
    { 
      type: 'meta_cumplida', 
      name: 'Meta Cumplida', 
      description: 'Felicitaciones por meta alcanzada', 
      color: '#10B981' 
    },
    { 
      type: 'documentos_pendientes', 
      name: 'Documentos Pendientes', 
      description: 'Recordatorio de documentos faltantes', 
      color: '#F59E0B' 
    },
    { 
      type: 'asignacion_concesionario', 
      name: 'Asignacion de Concesionario', 
      description: 'Detalles del concesionario y fecha de entrega', 
      color: '#3B82F6' 
    }
  ];

  const handleSendEmail = async (templateType, templateName) => {
    setSendingEmail(true);
    try {
      await api.post('/admin/send-email', {
        to_email: beneficiario.email,
        template_type: templateType,
        cedula: beneficiario.cedula,
        fecha_retiro: beneficiario.fecha_entrega || null
      });
      toast.success(`Correo "${templateName}" enviado a ${beneficiario.email}`);
      onClose();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al enviar correo');
    } finally {
      setSendingEmail(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent 
        className="bg-gradient-to-br from-[#2A2A2A] to-[#2A2A2A] border border-[#F5A623]/30 rounded-2xl p-6 max-w-2xl max-h-[85vh] overflow-y-auto" 
        data-testid="email-modal"
      >
        <DialogTitle className="text-xl font-heading font-bold text-[white] mb-3">
          Centro de Comunicaciones
        </DialogTitle>
        <DialogDescription className="text-[#666666] font-body text-sm mb-4">
          Enviar correos al cliente: <span className="text-white font-semibold">{beneficiario?.email}</span>
        </DialogDescription>
        
        <div className="space-y-2">
          {emailTemplates.map((template) => (
            <button
              key={template.type}
              disabled={sendingEmail || !beneficiario?.email}
              onClick={() => handleSendEmail(template.type, template.name)}
              className="w-full text-left p-3 bg-[#2A2A2A] border border-white/10 rounded-lg hover:border-[#F5A623] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              data-testid={`send-email-${template.type}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-white font-semibold text-sm">{template.name}</p>
                  <p className="text-[#666666] text-xs mt-0.5">{template.description}</p>
                </div>
                {sendingEmail ? (
                  <Loader2 className="w-5 h-5 text-[#F5A623] animate-spin flex-shrink-0" />
                ) : (
                  <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: template.color }} />
                )}
              </div>
            </button>
          ))}
        </div>
        
        {!beneficiario?.email && (
          <p className="text-[#EF4444] text-xs mt-3">El beneficiario no tiene email registrado</p>
        )}
      </DialogContent>
    </Dialog>
  );
}
